import {
    CHILD_CONNECT_ADMIN_FAILED,
    CHILD_CONNECT_ADMIN_FETCHING,
    CHILD_CONNECT_ADMIN_SUCCESS,
} from "../../Constants.ts";

export interface ChildConnectAdminState {
    isFetching: boolean;
    isError: boolean;
    result: any;
}

const initialState: ChildConnectAdminState = {
    isFetching: false,
    isError: false,
    result: null,
};

export default (state = initialState, { type, payload }: any): ChildConnectAdminState => {
    switch (type) {
        case CHILD_CONNECT_ADMIN_FETCHING:
            return { ...state, isFetching: true, isError: false, result: null };
        case CHILD_CONNECT_ADMIN_SUCCESS:
            return { ...state, isFetching: false, isError: false, result: payload };
        case CHILD_CONNECT_ADMIN_FAILED:
            return { ...state, isFetching: false, isError: true, result: null };
        default:
            return state;
    }
};
